export const NOTIFICATION_TYPE = {
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
};

export const LOCALE = {
  JAPANESE: "jp",
  ENGLISH: "en",
};

export const LOCAL_STORAGE_KEY = {
  USER_INFO: "user_info",
  USER_ID: "user_id",
  USER_TOKEN: "user_token",
  REFRESH_TOKEN: "refresh_token",
  LANGUAGE: "language",
  USER_GROUP: "user_group",
  SEARCH_CONDITIONS: "search_conditions",
  EXPIRE_TIME: "expire_time",
  LAST_EXPIRE_TIME: "last_expire_time",
  OWNER_ID: "owner_id",
  ORGANIZATION: "organization",
  REDIRECT: "redirect",
  DENSHI: "denshi",
  TOKUBAI: "tokubai",
  BIDASHBOARD: "bidashboard",
  FORECAST: "forecast",
  INTRANET: "intranet",
  ECM: "ecm",
  NEBIKI: "nebiki",
  BAKERY: "bakery",
  NOTIFICATION_PERMISIION: "notification_permission",
  LIST_USER: "list_user",
  ID_TOKEN: "idToken",
  REFRESH_TOKEN_AWS: "refreshToken",
  LOGIN_DEVICE: "loginDevice",
  REFRESH_ISSUED_AT: "refreshIssuedAt",
  REFRESH_EXPIRES_AT: "refreshExpiresAt",
};

export const ROLE_OPTIONS = [
  { value: "root", label: "ルート" },
  { value: "manager", label: "管理者" },
  { value: "normal", label: "一般" },
];

export const APPROVE_TAB = {
  ALL: "all",
  CREATE: "0",
  APPROVED: "1",
  REJECT: "2",
  WAITING_DELETE: "3",
  FORM_SHARED: "4",
};

export const SYSTEM_CONSTANT = {
  SYSTEM_HOURS_MINUTES_FORMAT: "HH:mm",
  SYSTEM_LOCAL_DATE_FORMAT: "yyyy-MM-DD",
  SYSTEM_LOCAL_DATE_FORMAT_YYYY_MM_DD: "yyyy/MM/DD",
  SYSTEM_LOCAL_DATE_TIME_FORMAT: "yyyy-MM-DD HH:mm",
  SYSTEM_LOCAL_DATE_TIME_FORMAT_YYYY_MM_DD: "yyyy/MM/DD HH:mm:ss",
  SYSTEM_LOCAL_DATE_TIME_STRING: "YYYYMMDDHHmmss",
};

export const REGEX_PHONE_NUMBER = /^0\d{9,10}$/;

export const REGEX_USERNAME = /^[a-zA-Z0-9._]*$/;
export const REGEX_VERIFICATION = /^[0-9]*$/;
export const REGEX_KATAKANA = /^([ｧ-ﾝﾞﾟァ-ン]|ー)*$/;
export const REGEX_PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\\[\]{}\\(\\)?\-“!@#%&/,><\\’:;|_~`])\S{8,99}$/;

export const SIGNIN_ERROR_TYPE = {
  USER_NOT_CONFIRMED: "User is not confirmed.",
  INCORRECT_USERNAME_OR_PASSWORD: "Incorrect username or password.",
  USER_NOT_EXIST: "User does not exist.",
  NEED_CONFIRM_FROM_ADMIN:
    "PreAuthentication failed with error Error: Needs confirmation from admin.",
  EMAIL_VERIFIED:
    "PreAuthentication failed with error Error: 'email_verified'.",
  EMAIL_NOT_VERIFIED:
    "PreAuthentication failed with error Error: Email not verified.",
};

export const SIGNUP_ERROR_TYPE = {
  USERNAME_EXISTS: "UsernameExistsException",
  EMAIL_EXISTS:
    "PreSignUp failed with error Error: User with this email already exists..",
};

export const CONFIRM_SIGNUP_ERROR_TYPE = {
  CODE_EXPIRED: "ExpiredCodeException",
  CODE_MISMATCH: "CodeMismatchException",
  CODE_INVALID: "InvalidParameterException",
};

export const FORGOT_PASSWORD_ERROR_TYPE = {
  CODE_INCORRECT: "CodeMismatchException",
  INVALID_EXCEPTION: "InvalidParameterException",
};

export const CHANGE_PASSWORD_ERROR_TYPE = {
  INCORRECT_PASSWORD: "Incorrect username or password.",
};

export const TOTAL_COUNT_INIT = 0;

export const PAGE_DEFAULT = 1;

export const PAGE_SIZE_DEFAULT = 20;

export const FORM_STATUS = {
  APPROVE: 1,
  REJECT: 2,
  CREATE: 0,
  WAITING_DELETE: 3,
};

export const USER_STATUS = {
  ACTIVE: "1",
  INACTIVE: "0",
};

export const USER_GROUP = {
  PLATFORM_ADMIN: "platform_admin",
  ADMIN: "admin",
  APPROVER: "approver",
  CREATOR: "creator",
};

export const USER_ROLE = {
  ROOT: "root",
  MANAGER: "manager",
  NORMAL: "normal",
};

export const FORM_TYPE = {
  REGISTER: "REGISTER",
  USER_DETAIL: "USER_DETAIL",
  USER_UPDATE: "USER_UPDATE",
  CREATE_USER: "CREATE_USER",
};

export const DEPARTMENT_OPTIONS = [
  {
    value: "01_共通",
    label: "01_共通",
  },
  {
    value: "10_青果",
    label: "10_青果",
  },
  {
    value: "20_鮮魚",
    label: "20_鮮魚",
  },
  {
    value: "30_精肉",
    label: "30_精肉",
  },
  {
    value: "45_総菜",
    label: "45_総菜",
  },
  {
    value: "48_ベーカリー",
    label: "48_ベーカリー",
  },
  {
    value: "50_グロサリー",
    label: "50_グロサリー",
  },
  {
    value: "70_コルモピア",
    label: "70_コルモピア",
  },
  {
    value: "90_チェックスタンド",
    label: "90_チェックスタンド",
  },
];

export const ROLE_REGISTER = [
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.NORMAL}`,
    label: "一般申請者",
  },
];

export const LIST_ORG = [
  "㈱ｻﾞｲﾏｯｸｽ",
  "東都ﾋﾞﾙ整備工業㈱",
  "㈱三機ｻｰﾋﾞｽ",
  "環境整備㈱",
  "古河電工ビジネス＆ライフサポート株式会社",
];

export const ALL_ROLE = [
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.ROOT}`,
    label: "プラットフォームルート",
  },
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.MANAGER}`,
    label: "プラットフォーム管理者",
  },
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.NORMAL}`,
    label: "プラットフォーム運用者",
  },
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.ROOT}`,
    label: "サービスルート",
  },
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.MANAGER}`,
    label: "サービス管理者",
  },
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.NORMAL}`,
    label: "サービス運用者",
  },
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.ROOT}`,
    label: "申請ルート",
  },
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.MANAGER}`,
    label: "申請管理者",
  },
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.NORMAL}`,
    label: "一般申請者",
  },
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.ROOT}`,
    label: "承認ルート",
  },
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.MANAGER}`,
    label: "承認管理者",
  },
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.NORMAL}`,
    label: "一般承認者",
  },
];

export const PLATFORM_UPDATE_ROLE = [
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.MANAGER}`,
    label: "プラットフォーム管理者",
  },
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.NORMAL}`,
    label: "プラットフォーム運用者",
  },
];

export const ADMIN_UPDATE_ROLE = [
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.MANAGER}`,
    label: "サービス管理者",
  },
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.NORMAL}`,
    label: "サービス運用者",
  },
];

export const APPROVER_UPDATE_ROLE = [
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.MANAGER}`,
    label: "承認管理者",
  },
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.NORMAL}`,
    label: "一般承認者",
  },
];

export const CREATOR_UPDATE_ROLE = [
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.MANAGER}`,
    label: "申請管理者",
  },
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.NORMAL}`,
    label: "一般申請者",
  },
];
